import { TFunction } from 'i18next';
import { ColumnProps } from 'primereact/column';

import { emptyCell } from '../../../../utils/constants/tables';
import { dateCell } from '../../../../utils/helpers/dataTable';
import { currencyFormat } from '../../../../utils/helpers/formatting';

export const tableStorageKey = 'dashboard_details_dataTable';

export function getColumnHeadersMap(t: TFunction) {
  return {
    seriskiBroj: t('Serial Number'),
    createdAt: t('Created Date'),
    datumPriem: t('Received Date'),
    datumIsporaka: t('Shipping Date'),
    statusName: t('Status'),
    klientDoIme: t('Recipient Name'),
    klientOdIme: t('Sender Name'),
    tezina: t('Weight'),
    volumen: t('Volume'),
    otkup: t('Redemption'),
    cena: t('Price'),
    komentar: t('Comment'),
    mobilenOd: t('Mobile from'),
    mobilenDo: t('Mobile to'),
    trackingNumber: t('Tracking number'),
    reference1: t('Reference1'),
    reference2: t('Reference 2'),
    groupSerialNumber: t('Group Serial Number'),
    modifiedAt: t('Modified at'),
  };
}

export function additionalColumnProperties(
  column: keyof ReturnType<typeof getColumnHeadersMap>
): Partial<ColumnProps> {
  switch (column) {
    case 'datumIsporaka':
    case 'datumPriem':
    case 'modifiedAt':
    case 'createdAt':
      return {
        body: (row) => dateCell(row[column]),
        style: {
          width: 180,
        },
        bodyStyle: {
          width: 180,
        },
      };

    case 'seriskiBroj':
    case 'statusName':
    case 'trackingNumber':
      return {
        style: {
          width: 220,
        },
        bodyStyle: {
          width: 220,
        },
      };

    case 'mobilenDo':
    case 'mobilenOd':
      return {
        style: {
          width: 200,
        },
        bodyStyle: {
          width: 200,
          textAlign: 'center',
        },
      };

    case 'tezina':
    case 'volumen':
      return {
        style: {
          width: 120,
          maxWidth: 100,
        },
        bodyStyle: {
          width: 120,
          maxWidth: 100,
          textAlign: 'center',
        },
      };

    case 'cena':
    case 'otkup':
      return {
        body: (row: any) => {
          return typeof row[column] === 'string' ||
            typeof row[column] === 'number'
            ? currencyFormat(row[column] as string, { showCurrency: true })
            : emptyCell;
        },
        style: {
          width: 120,
          maxWidth: 100,
        },
        bodyStyle: {
          width: 120,
          maxWidth: 100,
          textAlign: 'center',
        },
      };

    case 'komentar':
    case 'reference1':
    case 'reference2':
    case 'groupSerialNumber':
      return {
        body: (row: any) => (!!row[column]?.trim() ? row[column] : emptyCell),
        style: {
          width: 180,
        },
        bodyStyle: {
          width: 180,
        },
      };

    default:
      return {};
  }
}
